var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "app-dialer-main-popup",
      staticClass: "app-dialer-main-popup",
      class: ((_obj = {}), (_obj["is-" + _vm.display] = true), _obj),
      style: _vm.componentStyle,
      attrs: { "data-draggable": "" },
    },
    [
      _c(
        "div",
        { staticClass: "row primary", attrs: { "data-draggable": "" } },
        [
          _c(
            "div",
            { staticClass: "popup-info" },
            [
              _c("base-icon-button", {
                attrs: { icon: "push_pin", "data-action": "toggle-pin" },
                on: { click: _vm.onTogglePin },
              }),
              _vm._v(" "),
              _c("app-dialer-call-card-info", {
                attrs: {
                  avatar: _vm.avatar,
                  agent: _vm.agent,
                  contact: _vm.contact,
                  identifier: _vm.identifier,
                  members: _vm.members,
                  "is-expanded": _vm.isMembersPopupActive,
                  "show-info-button": !!_vm.description,
                  "is-info-button-active": _vm.isInfoActive,
                },
                on: {
                  "toggle-info": function ($event) {
                    return _vm.$emit("toggle-info")
                  },
                  "toggle-members": function ($event) {
                    return _vm.$emit("toggle-members-popup")
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.display === "popup"
            ? _c("div", { staticClass: "divider" })
            : _vm._e(),
          _vm._v(" "),
          _c("app-dialer-call-status", {
            attrs: {
              timestamp: _vm.timestamp,
              "session-id": _vm.sessionId,
              "is-connecting": _vm.isConnecting,
              "is-in-progress": _vm.isInProgress,
            },
          }),
          _vm._v(" "),
          _vm.display === "popup"
            ? _c("div", { staticClass: "divider" })
            : _vm._e(),
          _vm._v(" "),
          _c("app-dialer-call-controls", {
            attrs: {
              "is-on-hold": _vm.isOnHold,
              "is-muted": _vm.isMuted,
              "is-put-on-hold-action-loading": _vm.isPutOnHoldActionLoading,
              "is-hang-up-action-loading": _vm.isHangUpActionLoading,
              "is-keypad-active": _vm.isKeypadActive,
              "is-invite-button-active": _vm.isInvitePopupActive,
              "is-transfer-button-active": _vm.isTransferPopupActive,
              "is-connecting": _vm.isConnecting,
              "has-keypad-button": _vm.hasKeypadButton,
              "has-invite-button": _vm.hasInviteButton,
              "has-transfer-button": _vm.hasTransferButton,
              "has-hold-button": _vm.hasHoldButton,
              "has-mute-button": _vm.hasMuteButton,
              "has-contact-member-on-call": _vm.hasContactMemberOnCall,
            },
            on: {
              "toggle-keypad": function ($event) {
                return _vm.$emit("toggle-keypad", $event)
              },
              "toggle-invite": function ($event) {
                return _vm.$emit("toggle-invite-popup", $event)
              },
              "toggle-transfer": function ($event) {
                return _vm.$emit("toggle-transfer-popup", $event)
              },
              "put-on-hold": function ($event) {
                return _vm.$emit("put-on-hold", $event)
              },
              "mute-self": function ($event) {
                return _vm.$emit("mute-self", $event)
              },
              "hang-up": function ($event) {
                return _vm.$emit("hang-up", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showGoToButton
        ? _c(
            "div",
            { staticClass: "row secondary", attrs: { "data-draggable": "" } },
            [
              _c(
                "div",
                {
                  attrs: { "data-button": "go-to-session" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("go-to-session")
                    },
                  },
                },
                [
                  _c(
                    "or-tooltip",
                    {
                      attrs: {
                        content: _vm.$t(
                          "hitl.modules.dialer.go-to-session-description"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("hitl.modules.dialer.go-to-session")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }